import Vue from 'vue'
import Router from 'vue-router'
Vue.use(Router)
const Home=resolve=>{
	require.ensure(['@/pages/Index'],()=>{
		resolve(require('@/pages/Index'));
	},'Home');
};
const SearchList=resolve=>{
	require.ensure(['@/pages/List'],()=>{
		resolve(require('@/pages/List'));
	},'SearchList');
};
export default new Router({
  mode: 'history',//路由模式
  scrollBehavior(to,from,savedPosition){//滚动行为
    if (savedPosition) {//在按下 后退/前进 按钮时
      return savedPosition;
    }
    if(to.hash){//滚动到锚点
      return {
        selector:to.hash
      }
    }
    return {x:0,y:0};
  },
  routes:[
    { path: '*', redirect:'/' },//重定向
    {//配置首页
      path: '/',
      component:Home,
			name:'Home',
    },
    {//配置首页
      path: '/:type/list',
      component:SearchList,
			name:'SearchList',
    },
  ]
});



// WEBPACK FOOTER //
// ./src/router/index.js